import type { FC } from 'react';

const LogoutIcon: FC = () => (
    <svg width="240" height="140" viewBox="0 0 240 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6488_33924)">
            <path
                d="M239.5 139.3H0V134.7C0 74.3 48.9 25.4 109.3 25.4H130.2C190.6 25.4 239.5 74.3 239.5 134.7V139.3Z"
                fill="#F2FCFC"
            />
            <path
                d="M17.1 68.8C14.9 78.9 11.2 105.1 29.4 111.3C30.3 111.6 31.5 111.3 32.2 110.5C44.6 95.9 28 75.3 21 67.8C19.9 66.6 17.5 67.3 17.1 68.8Z"
                fill="#1BB798"
            />
            <path
                d="M53.0002 76.0999C43.3002 79.3999 19.5002 89.7999 27.6002 109.2C28.0002 110.2 29.1002 111.1 30.2002 111.3C50.9002 114.7 55.6002 89.1999 56.6002 78.9999C56.8002 77.3999 54.5002 75.5999 53.0002 76.0999Z"
                fill="#1BB798"
            />
            <path
                d="M10.6001 99.4999C12.7001 104.8 19.1001 117.6 29.6001 112.6C30.1001 112.3 30.6001 111.7 30.7001 111.1C32.0001 99.5999 17.7001 97.6999 12.0001 97.3999C11.2001 97.3999 10.2001 98.6999 10.6001 99.4999Z"
                fill="#1BB798"
            />
            <path
                d="M21.6001 80.6C21.6001 80.6 29.2001 105.5 29.2001 116.2C29.2001 122.3 48.5001 87.2 48.5001 87.2"
                stroke="#191445"
                stroke-width="0.4445"
                stroke-miterlimit="10"
            />
            <path
                d="M50.6001 109.8H10.2001C10.2001 109.8 7.80012 138.7 30.4001 138.7C53.0001 138.7 50.6001 109.8 50.6001 109.8Z"
                fill="#05748C"
            />
            <path
                d="M45.5002 139.7H15.3002C14.1002 139.7 13.2002 138.7 13.2002 137.6V133.3C13.2002 133 13.5002 132.7 13.8002 132.7H46.8002C47.3002 132.7 47.6002 133.1 47.6002 133.5V137.6C47.6002 138.8 46.7002 139.7 45.5002 139.7Z"
                fill="#05748C"
            />
            <path
                d="M193.9 4.1C193.9 1.8 192.1 0 189.8 0H44.2001C41.9001 0 40.1001 1.8 40.1001 4.1V86.4V92.9V98.9V105.4V105.8C40.1001 106.8 40.5001 107.8 41.1001 108.5L41.2001 108.6L41.3001 108.7C42.0001 109.4 42.8001 109.9 43.8001 109.9H190.1C191.1 109.9 191.9 109.5 192.6 108.7L192.7 108.6L192.8 108.5C193.4 107.8 193.8 106.8 193.8 105.8V4.1H193.9Z"
                fill="#565656"
            />
            <path
                d="M134 133.5L137.5 108.3H85.2001L81.7001 133.5H81.6001V136.2C81.6001 137.9 82.9001 139.2 84.6001 139.2H155.7V133.5H134Z"
                fill="#B3B3B3"
            />
            <path
                d="M200.4 96.9V4.1C200.4 1.8 198.6 0 196.3 0H50.7001C48.4001 0 46.6001 1.8 46.6001 4.1V96.9H200.4Z"
                fill="#343741"
            />
            <path d="M137.5 134.3H85.3L88.8 108.3H141.1L137.5 134.3Z" fill="#BFC0BF" />
            <path
                d="M155.7 139.3H84.6001C82.9001 139.3 81.6001 138 81.6001 136.3V133.6H155.7V139.3Z"
                fill="#D9D9D9"
            />
            <path
                d="M163.4 139.3H118V136.6C118 134.9 119.3 133.6 121 133.6H160.4C162.1 133.6 163.4 134.9 163.4 136.6V139.3Z"
                fill="#F0F0F0"
            />
            <path
                d="M51.6001 101.5V8.5C51.6001 7.1 52.7001 6 54.1001 6H192.9C194.3 6 195.4 7.1 195.4 8.5V101.5C195.4 102.9 194.3 104 192.9 104H54.1001C52.7001 104 51.6001 102.8 51.6001 101.5Z"
                fill="white"
            />
            <path
                d="M46.6001 86.4V99C46.6001 101.5 48.3001 103.5 50.3001 103.5H196.6C198.7 103.5 200.3 101.5 200.3 99V86.4H46.6001Z"
                fill="#343741"
            />
            <path
                d="M46.6001 92.9V105.4C46.6001 107.9 48.3001 109.9 50.3001 109.9H196.6C198.7 109.9 200.3 107.9 200.3 105.4V92.9H46.6001Z"
                fill="#D9D9D9"
            />
            <path
                d="M194.6 128.9C194.6 128.2 195.2 127.7 195.8 127.7H197.3C198 127.7 198.5 128.3 198.5 128.9C198.5 129.6 197.9 130.1 197.3 130.1H195.8C195.1 130.2 194.6 129.6 194.6 128.9Z"
                fill="#343741"
            />
            <path
                d="M185.9 139.2C185.9 133.3 190.7 128.5 196.6 128.5C202.5 128.5 207.3 133.3 207.3 139.2"
                fill="#D9D9D9"
            />
            <path d="M204.2 128.6H195.6V139.3H204.2V128.6Z" fill="#D9D9D9" />
            <path
                d="M214.8 139.2C214.8 133.3 210 128.5 204.1 128.5C198.2 128.5 193.4 133.3 193.4 139.2H214.8Z"
                fill="#D9D9D9"
            />
            <path
                d="M113.8 49.3C112.7 49.3 111.8 48.4 111.8 47.3V39.1C111.8 32.9 116.9 27.8 123.1 27.8C129.3 27.8 134.4 32.9 134.4 39.1V39.7001C134.4 40.8001 133.5 41.7001 132.4 41.7001C131.3 41.7001 130.4 40.8001 130.4 39.7001V39.1C130.4 35.1 127.1 31.8 123.1 31.8C119.1 31.8 115.8 35.1 115.8 39.1V47.3C115.8 48.5 114.9 49.3 113.8 49.3Z"
                fill="#8DC4C6"
            />
            <path
                d="M135.5 71H110.6C108.3 71 106.4 69.1001 106.4 66.8001V50C106.4 47.7 108.3 45.8 110.6 45.8H135.5C137.8 45.8 139.7 47.7 139.7 50V66.9001C139.7 69.2001 137.8 71 135.5 71Z"
                fill="#05748C"
            />
            <path
                d="M126.8 55.9C126.8 54 125.3 52.5 123.4 52.5C121.5 52.5 120 54 120 55.9C120 57.3 120.8 58.5 122 59V62.9C122 63.7 122.7 64.4 123.5 64.4C124.3 64.4 125 63.7 125 62.9V59C126 58.4 126.8 57.3 126.8 55.9Z"
                fill="white"
            />
            <path d="M195.4 6H51.6001V14.7H195.4V6Z" fill="#FFD000" />
        </g>
        <defs>
            <clipPath id="clip0_6488_33924">
                <rect width="239.5" height="139.7" fill="white" />
            </clipPath>
        </defs>
    </svg>

);

export default LogoutIcon;
